import {Component, inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NavElement} from '@bvgo-ict/vwui-angular';
import {MenuBuilder, UserService} from '../../services';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy {
    private menuBuilder = inject(MenuBuilder);
    private userService = inject(UserService);

    public navItems: NavElement[];
    private userInfoSubscription: Subscription;
    private myType: string;

    get type(): string {
        return this.myType;
    }

    @Input()
    set type(type: string) {
        this.myType = type;
        this.updateMenu();
    }

    async ngOnInit() {
        this.userInfoSubscription = this.userService.onUserInfoChange().subscribe((_) => {
            this.updateMenu();
        });
    }

    ngOnDestroy() {
        this.userInfoSubscription.unsubscribe();
    }

    private updateMenu() {
        this.menuBuilder.buildProjectsMenu().then((navItems) => this.navItems = navItems);
    }
}
